/* eslint-disable import/no-cycle */
import {createContext} from 'react';
import {AuthStore} from './authStore';
import {BatchQueueItemStore} from './batchQueueItemStore';
import {BatchStore} from './batchStore';
import {ClientStore} from './clientStore';
import {CockpitDashboardStore} from './cockpitDashboardStore';
import {CockpitStore} from './cockpitStore';
import {CockpitWidgetStore} from './cockpitWidgetStore';
import {ComponentStore} from './componentStore';
import {ConsumptionStore} from './consumptionStore';
import {ContextStore} from './contextStore';
import {CustomActionStore} from './customActionStore';
import {CustomFunctionStore} from './customFunctionStore';
import {CustomPropertyStore} from './customPropertyStore';
import {DocumentStore} from './documentStore';
import {DocumentTypeStore} from './documentTypeStore';
import {EventLogStore} from './eventLogStore';
import {ExternalResourceStore} from './externalResourceStore';
import {FlashMessageStore} from './flashMessageStore';
import {HierarchyStore} from './hierarchyStore';
import {IngredientStore} from './ingredientStore';
import {InspectionLotStore} from './inspectionLotStore';
import {InspectionTaskGroupStore} from './inspectionTaskGroupStore';
import {InspectionTaskPendingStore} from './inspectionTaskPendingStore';
import {InspectionTaskResultStore} from './inspectionTaskResultStore';
import {InspectionTaskStore} from './inspectionTaskStore';
import {InspectionPlanStore} from './inspectionPlanStore';
import {InterruptionReasonSourceStore} from './interruptionReasonSourceStore';
import {InterruptionReasonStore} from './interruptionReasonStore';
import {KeyPerformanceIndicatorExportTemplateStore} from './keyPerformanceIndicatorExportTemplateStore';
import {KeyPerformanceIndicatorStore} from './keyPerformanceIndicatorStore';
import {KeyPerformanceIndicatorTargetStore} from './keyPerformanceIndicatorTargetStore';
import {LdapConnectionStore} from './ldapConnectionStore';
import {LdapFieldMappingStore} from './ldapFieldMappingStore';
import {LdapGroupStore} from './ldapGroupStore';
import {MaterialStore} from './materialStore';
import {BatchGeneratorFunctionStore} from './batchGeneratorFunctionStore';
import {MessageReadStore} from './messageReadStore';
import {MessageStore} from './messageStore';
import {MqttStore} from './mqttStore';
import {ObjectLockStore} from './objectLockStore';
import {OperationMessageStore} from './operationMessageStore';
import {OperationPhaseStore} from './operationPhaseStore';
import {OperationStateLogStore} from './operationStateLogStore';
import {OperationStateStore} from './operationStateStore';
import {OperationsStore} from './operationsStore';
import {OrderComponentStore} from './orderComponentStore';
import {OrderStore} from './orderStore';
import {PerformanceAnalysisStore} from './performanceAnalysisStore';
import {PermissionStore} from './permissionStore';
import {PersonnelLogStore} from './personnelLogStore';
import {PhaseStore} from './phaseStore';
import {PopupMessageStore} from './popupMessageStore';
import {PreparationStore} from './preparationStore';
import {RelevantMessagesStore} from './relevantMessagesStore';
import {ReportLogStore} from './reportLogStore';
import {ReportTypeStore} from './reportTypeStore';
import {RoleStore} from './roleStore';
import {SensorDataStore} from './sensorDataStore';
import {SensorDataTargetStore} from './sensorDataTargetStore';
import {SensorStore} from './sensorStore';
import {SettingStore} from './settingStore';
import {ShiftBookStore} from './shiftBookStore';
import {ShiftStore} from './shiftStore';
import {StateHistoryStore} from './stateHistoryStore';
import {StorageUnitStore} from './storageUnitStore';
import {TerminalLayoutsStore} from './terminalLayoutsStore';
import {TerminalStore} from './terminalStore';
import {TransitionStore} from './transitionStore';
import {UnitOfMeasurementConversionStore} from './unitOfMeasurementConversionStore';
import {UnitOfMeasurementStore} from './unitOfMeasurementStore';
import {UserRoleStore} from './userRoleStore';
import {UserStore} from './userStore';
import {ValidStartTransitionsStore} from './validStartTransitionsStore';
import {ValidTransitionsStore} from './validTransitionsStore';
import {WorkflowCorrectionStore} from './workflowCorrectionStore';
import {WorkflowStore} from './workflowStore';
import {WorkplaceGroupStore} from './workplaceGroupStore';
import {WorkplaceStateLogStore} from './workplaceStateLogStore';
import {WorkplaceStateStore} from './workplaceStateStore';
import {WorkplaceStore} from './workplaceStore';
import {YieldStore} from './yieldStore';
import {YieldTypeStore} from './yieldTypeStore';
import {MaterialSensorStore} from './materialSensorStore';
import {MesConfigStore} from './mesConfigStore';

export class RootStore {
  constructor() {
    this.authStore = new AuthStore(this);
    this.batchQueueItemStore = new BatchQueueItemStore(this);
    this.batchStore = new BatchStore(this);
    this.batchGeneratorFunctionStore = new BatchGeneratorFunctionStore(this);
    this.clientStore = new ClientStore(this);
    this.cockpitDashboardStore = new CockpitDashboardStore(this);
    this.cockpitStore = new CockpitStore(this);
    this.cockpitWidgetStore = new CockpitWidgetStore(this);
    this.componentStore = new ComponentStore(this);
    this.consumptionStore = new ConsumptionStore(this);
    this.contextStore = new ContextStore(this);
    this.customActionStore = new CustomActionStore(this);
    this.customFunctionStore = new CustomFunctionStore(this);
    this.documentStore = new DocumentStore(this);
    this.documentTypeStore = new DocumentTypeStore(this);
    this.eventLogStore = new EventLogStore(this);
    this.externalResourceStore = new ExternalResourceStore(this);
    this.flashMessageStore = new FlashMessageStore(this);
    this.hierarchyStore = new HierarchyStore(this);
    this.ingredientStore = new IngredientStore(this);
    this.inspectionLotStore = new InspectionLotStore(this);
    this.inspectionTaskGroupStore = new InspectionTaskGroupStore(this);
    this.inspectionTaskPendingStore = new InspectionTaskPendingStore(this);
    this.inspectionTaskResultStore = new InspectionTaskResultStore(this);
    this.inspectionTaskStore = new InspectionTaskStore(this);
    this.inspectionPlanStore = new InspectionPlanStore(this);
    this.interruptionReasonSourceStore = new InterruptionReasonSourceStore(this);
    this.interruptionReasonStore = new InterruptionReasonStore(this);
    this.keyPerformanceIndicatorExportTemplateStore = new KeyPerformanceIndicatorExportTemplateStore(this);
    this.keyPerformanceIndicatorStore = new KeyPerformanceIndicatorStore(this);
    this.keyPerformanceIndicatorTargetStore = new KeyPerformanceIndicatorTargetStore(this);
    this.ldapConnectionStore = new LdapConnectionStore(this);
    this.ldapFieldMappingStore = new LdapFieldMappingStore(this);
    this.ldapGroupStore = new LdapGroupStore(this);
    this.materialStore = new MaterialStore(this);
    this.materialSensorStore = new MaterialSensorStore(this);
    this.mesConfigStore = new MesConfigStore(this);
    this.messageReadStore = new MessageReadStore(this);
    this.messageStore = new MessageStore(this);
    this.mqttStore = new MqttStore(this);
    this.objectLockStore = new ObjectLockStore(this);
    this.operationMessageStore = new OperationMessageStore(this);
    this.operationPhaseStore = new OperationPhaseStore(this);
    this.operationStateLogStore = new OperationStateLogStore(this);
    this.operationStateStore = new OperationStateStore(this);
    this.operationStore = new OperationsStore(this);
    this.orderComponentStore = new OrderComponentStore(this);
    this.orderStore = new OrderStore(this);
    this.performanceAnalysisStore = new PerformanceAnalysisStore(this);
    this.permissionStore = new PermissionStore(this);
    this.personnelLogStore = new PersonnelLogStore(this);
    this.phaseStore = new PhaseStore(this);
    this.popupMessageStore = new PopupMessageStore(this);
    this.preparationStore = new PreparationStore(this);
    this.propertyStore = new CustomPropertyStore(this);
    this.relevantMessagesStore = new RelevantMessagesStore(this);
    this.reportLogStore = new ReportLogStore(this);
    this.reportTypeStore = new ReportTypeStore(this);
    this.roleStore = new RoleStore(this);
    this.sensorDataStore = new SensorDataStore(this);
    this.sensorDataTargetStore = new SensorDataTargetStore(this);
    this.sensorStore = new SensorStore(this);
    this.settingStore = new SettingStore(this);
    this.shiftBookStore = new ShiftBookStore(this);
    this.shiftStore = new ShiftStore(this);
    this.stateHistoryStore = new StateHistoryStore(this);
    this.storageUnitStore = new StorageUnitStore(this);
    this.terminalLayoutsStore = new TerminalLayoutsStore(this);
    this.terminalStore = new TerminalStore(this);
    this.transitionStore = new TransitionStore(this);
    this.unitOfMeasurementConversionStore = new UnitOfMeasurementConversionStore(this);
    this.unitOfMeasurementStore = new UnitOfMeasurementStore(this);
    this.userRoleStore = new UserRoleStore(this);
    this.userStore = new UserStore(this);
    this.validStartTransitionsStore = new ValidStartTransitionsStore(this);
    this.validTransitionsStore = new ValidTransitionsStore(this);
    this.workflowCorrectionStore = new WorkflowCorrectionStore(this);
    this.workflowStore = new WorkflowStore(this);
    this.workplaceGroupStore = new WorkplaceGroupStore(this);
    this.workplaceStateLogStore = new WorkplaceStateLogStore(this);
    this.workplaceStateStore = new WorkplaceStateStore(this);
    this.workplaceStore = new WorkplaceStore(this);
    this.yieldStore = new YieldStore(this);
    this.yieldTypeStore = new YieldTypeStore(this);
  }

  clear() {
    // call clear on all properties (stores) that have a clear method
    // eslint-disable-next-line no-restricted-syntax
    for (const property in this) {
      if (
        property
        // eslint-disable-next-line no-prototype-builtins
        && this.hasOwnProperty(property)
        && typeof this[property] === 'object'
        && typeof this[property].clear === 'function'
      ) {
        this[property].clear();
      }
    }
  }
}

export const rootStoreInstance = new RootStore();
export const StoreContext = createContext(rootStoreInstance);
